/**
 * Реестр тем города. id совпадает с полем theme из API (city/user-city).
 * Новая тема: добавить запись здесь + стили/ассеты в src/styles/theme/<id>/
 */
export const CITY_THEMES = {
  disney: {
    id: 'disney',
    bodyClass: 'theme-disney',
    themeColor: '#97add4',
    visual: false,
  },
  mothersDay: {
    id: 'mothersDay',
    bodyClass: 'theme-mothers-day',
    themeColor: '#f5ebe0',
  },
  childrenDay: {
    id: 'childrenDay',
    bodyClass: 'theme-children-day',
    themeColor: '#f4e8dc',
  },
};

/** @deprecated use CITY_THEMES.disney.id */
export const CITY_THEME_DISNEY = CITY_THEMES.disney.id;
/** @deprecated use CITY_THEMES.mothersDay.id */
export const CITY_THEME_MOTHERS_DAY = CITY_THEMES.mothersDay.id;
/** @deprecated use CITY_THEMES.childrenDay.id */
export const CITY_THEME_CHILDRENS_DAY = CITY_THEMES.childrenDay.id;

const THEME_BODY_CLASSES = Object.values(CITY_THEMES).map(theme => theme.bodyClass);

export function getCityTheme(userCity) {
  return userCity?.theme || '';
}

export function getCityThemeConfig(themeId) {
  return themeId ? CITY_THEMES[themeId] || null : null;
}

export function isKnownCityTheme(themeId) {
  return Boolean(themeId && CITY_THEMES[themeId]);
}

/**
 * Dev-only: ?theme=<id> — превью, если тема есть в реестре, а API ещё не отдаёт theme.
 */
function getDevThemePreview(userCity) {
  if (!__DEV__ || typeof window === 'undefined' || getCityTheme(userCity)) {
    return null;
  }

  const previewId = new URLSearchParams(window.location.search).get('theme');
  return isKnownCityTheme(previewId) ? previewId : null;
}

/**
 * Активная тема: значение с API, если оно есть в реестре, иначе dev-превью, иначе null.
 */
export function getActiveCityTheme(userCity) {
  const apiTheme = getCityTheme(userCity);

  if (isKnownCityTheme(apiTheme)) {
    return apiTheme;
  }

  return getDevThemePreview(userCity);
}

export function isThemeActive(userCity, themeId) {
  return getActiveCityTheme(userCity) === themeId;
}

export function isThemeVisualEnabled(themeId) {
  const config = getCityThemeConfig(themeId);
  return Boolean(config && config.visual !== false);
}

export function getVisualActiveCityTheme(userCity) {
  const activeTheme = getActiveCityTheme(userCity);
  return isThemeVisualEnabled(activeTheme) ? activeTheme : null;
}

export function isVisualThemeActive(userCity, themeId) {
  return isThemeActive(userCity, themeId) && isThemeVisualEnabled(themeId);
}

function resolveVisualThemeId(activeThemeId) {
  return isThemeVisualEnabled(activeThemeId) ? activeThemeId : null;
}

export function isDisneyThemeActive(userCity) {
  return isThemeActive(userCity, CITY_THEME_DISNEY);
}

export function isMothersDayThemeActive(userCity) {
  return isThemeActive(userCity, CITY_THEME_MOTHERS_DAY);
}

export function isChildrenDayThemeActive(userCity) {
  return isThemeActive(userCity, CITY_THEME_CHILDRENS_DAY);
}

/** Синхронизирует классы и data-city-theme на body (все зарегистрированные темы). */
export function syncBodyCityTheme(activeThemeId) {
  if (typeof document === 'undefined') {
    return;
  }

  THEME_BODY_CLASSES.forEach(bodyClass => {
    document.body.classList.remove(bodyClass);
  });

  const config = getCityThemeConfig(resolveVisualThemeId(activeThemeId));

  if (config) {
    document.body.classList.add(config.bodyClass);
    document.body.setAttribute('data-city-theme', config.id);
  } else {
    document.body.removeAttribute('data-city-theme');
  }
}

export function getThemeBodyClassNames(activeThemeId) {
  const visualThemeId = resolveVisualThemeId(activeThemeId);

  return Object.values(CITY_THEMES).reduce((acc, theme) => {
    acc[theme.bodyClass] = visualThemeId === theme.id;
    return acc;
  }, {});
}
